export const REFERRAL_LOGIN_FORM = "REFERRAL_LOGIN_FORM"
export const LOGIN_FORM = "LOGIN_FORM"
export const REGISTER_FORM = "REGISTER_FORM"
export const FORGOT_PASSWORD_FORM = "FORGOT_PASSWORD_FORM"
export const RESET_PASSWORD_FORM = "RESET_PASSWORD_FORM"
export const CONFIRM = "CONFIRM"